// safe-gameplay-wrapper.tsx
import React, { memo } from 'react'


interface SafeGameplayWrapperProps {
  gameplayStyle?: React.CSSProperties // Mark as optional to filter it out
  children: React.ReactNode
}

const SafeGameplayWrapper: React.FC<SafeGameplayWrapperProps> = memo((props) => {
  const { gameplayStyle, children, ...validProps } = props

  // Log the issue for debugging
  if (gameplayStyle) {
    console.warn('Invalid prop `gameplayStyle` was passed to a DOM element. Please fix this in the React component.', {
      gameplayStyle,
      component: 'SafeGameplayWrapper',
    })
  }

  return (<div
    {...validProps}
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      ...gameplayStyle, // Merges default styles with the passed-in gameplayStyle
    }}
    >
      {children}
    </div>
  )
})

export default SafeGameplayWrapper
